import React from 'react';

import Group from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';
import Typography from '@pb/kit-component-typography';

import {docLink, instructionsList, instructionsSection} from '../upload-metadata.module.styl';
import {PROVIDER_INSTRUCTIONS} from '../utils/provider-instructions-data';


type ProviderInstructionsProps = {
    providerId: string | null,
    tabKey: 'url' | 'file' | 'manual',
};

const TAB_INSTRUCTION_KEY: Record<string, 'urlInstructions' | 'fileInstructions' | 'manualInstructions'> = {
    url: 'urlInstructions',
    file: 'fileInstructions',
    manual: 'manualInstructions',
};

export const ProviderInstructions: React.FC<ProviderInstructionsProps> = ({providerId, tabKey}) => {

    const provider = PROVIDER_INSTRUCTIONS[providerId ?? 'other'] ?? PROVIDER_INSTRUCTIONS.other;
    const steps = provider[TAB_INSTRUCTION_KEY[tabKey]];

    return (
        <div className={instructionsSection}>
            <Typography variant="body-level-1" style={{fontWeight: 600}}>
                How to find your metadata file in your Identity Provider
            </Typography>

            <Group direction="v" gap="s" style={{paddingTop: 12}}>
                <ol className={instructionsList}>
                    {steps.map((step, index) => (
                        <li key={index}>{step}</li>
                    ))}
                </ol>
                {provider.docUrl ? (
                    <a
                        href={provider.docUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={docLink}>
                        {provider.docLabel}
                        <Icon type={Icons.EXTERNAL_LINK} size="Size_12"/>
                    </a>
                ) : null}
                {provider.pdfGuide ? (
                    <a
                        href={provider.pdfGuide.url}
                        download={true}
                        className={docLink}>
                        {provider.pdfGuide.label}
                        <Icon type={Icons.DOWNLOAD} size="Size_12"/>
                    </a>
                ) : null}
            </Group>
        </div>
    );
};
